import { currentUser } from "@shared/Helpers/encryptionHelpers";
import Hero from "../components/Hero/Hero";
import Introduction from "../components/Introduction/Introduction";
import TopCourses from "../components/TopCourses/TopCourses";
import WhyUs from "../components/WhyUs/WhyUs";
import Footer from "../components/Footer/Footer";
import { Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";
// import PropTypes, { func } from "prop-types";

export const Home = () => {
  // ----------- hooks ----------
  const navigate = useNavigate();
  const userData = currentUser();

  // ----------- functions ------------

  // ----------- side effects ------------
  useEffect(() => {
    if (userData?.role) {
      userData?.role === "Student" ? navigate("/home") : navigate("/dashboard");
    }
  });

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((el) => observer.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  if (currentUser()?.role == "Admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <Hero />
      <Introduction />
      <WhyUs />
      <TopCourses />
      <Footer />
    </>
  );
};

Home.propTypes = {
  // Home: PropTypes.any,
};
